import React, { useState, useEffect, memo } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Box, Grid } from '@material-ui/core'

import _, { get } from 'lodash'
import { Route, Redirect } from 'react-router-dom'

import EditComponent from '../EntryListAndEdit/EditComponent.js'
import AddComponent from '../EntryListAndEdit/AddComponent.js'
import ViewComponent from '../EntryListAndEdit/ViewComponent.js'

import {utc_timestamp_to_local_date_string, utc_timestamp_to_hours_ago_string, utc_timestamp_to_local_datetime_string} from '../../utils/datetime_utc_local.js'
import {ecosackState} from "../../utils/ecosackState.js";

const useStyles = makeStyles((theme) => ({
  textAlignRight: { textAlign: 'right' },

  searchControls: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
  },

  searchLabel: {
    display: 'inline-block',
  },
}))

const PaginatedList = (props) => {
  const classes = useStyles()

  const auth = useSelector(state => state.auth)
  const [entries, setEntries] = useState([])
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(0)
  const [numPages, setNumPages] = useState(1)
  const [total, setTotal] = useState(0)
  const [pagelinks, setPagelinks] = useState([])
  const [searchterm, setSearchterm] = useState("")
  const [dateSearchterm, setDateSearchterm] = useState("")

  const {
    list_get_url,
    detail_get_url,
    add_new_url,
    view_request,
    view_fields,
    date_search,
    show_timestamp_time,

    column_names = [],
    header_names = [],
    optional_column_names = [],
    optional_header_names = [],

    editable_fields = [],
  } = props;

  useEffect(() => {
    const fetchListData = async () => {
      const config = { headers: { 'Content-Type': 'application/json' } }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      var results;
      const combinedSearch = [searchterm.trim(), dateSearchterm]
        .filter(Boolean)
        .join(" ")

      if (combinedSearch === "") {
        results = await axios.get(list_get_url + page, config)
      } else {
        results = await axios.get(
          list_get_url + encodeURIComponent(combinedSearch) + "/" + page,
          config
        )
      }

      setTotal(results.data.total)
      setNumPages(results.data.pages)
      setPerPage(results.data.per_page)

      let these_pagelinks = [];
      for(var i=1; i<results.data.pages+1; i++){
        these_pagelinks.push(i)
      }
      setPagelinks(these_pagelinks);

      console.log(these_pagelinks);

      for (var i in results.data.items) {
        for (const [key, value] of Object.entries(results.data.items[i])) {
          if (key == 'balance' || key == 'donated' || key == 'earned redemption' || key == 'withdrawn') {
            results.data.items[i][key] = '$' + (results.data.items[i][key] / 1e6);
          }
          // boolean field from ecocontrol qr logins attempts
          if (key == 'valid') {
            results.data.items[i][key] = results.data.items[i][key] ? "Yes" : "No";
          }
          if (key == 'timestamp' && show_timestamp_time) {
            results.data.items[i][key] = utc_timestamp_to_local_datetime_string(
              results.data.items[i][key]
            );
          } else if (key == 'timestamp'|| key == 'created' || key == 'last_updated') {
            results.data.items[i][key] = utc_timestamp_to_local_date_string(results.data.items[i][key]);
          }
        }
      }

      setEntries(results.data.items)
    }

    fetchListData();

    window.addEventListener('customertable_is_dirty', fetchListData);

    return () => {
      window.removeEventListener('customertable_is_dirty', fetchListData);
    };
  }, [page, searchterm, dateSearchterm, list_get_url])

  const onChangeSearchterm = (event) => {
    setSearchterm(event.target.value)
  };
  
  const onChangeDate = (event) => {
    const v = event.target.value
    setPage(1)

    if (!v) {
      setDateSearchterm("")
      return
    }

    const [year, month, day] = v.split("-").map(Number)

    const start = new Date(year, month - 1, day)
    const end = new Date(year, month - 1, day + 1)

    setDateSearchterm(`date:${start.getTime()}-${end.getTime()}`)
  }

  if (!auth.access_token) {
    return <Redirect to="/login" />
  }

  function createPaginationLinks(top){
    return <Grid container>
        <br/>
        <Grid sm={12} md={8}>
            {page > 1 &&
                <span onClick={() => setPage(page-1)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>&lt;&lt;</span>
             }
             {page == 1 &&
                <span style={{'marginRight':'5px', 'opacity':0.3}}>&lt;&lt;</span>
             }

            {pagelinks.length <= 10 &&
                _.map(pagelinks, pl =>{
                    if(pl == page){
                        return <span style={{'marginRight':'5px', 'textDecoration':'underline', 'opacity':0.3}}>{pl}</span>
                    }else{
                        return <span onClick={() => setPage(pl)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>{pl}</span>
                    }
                })
            }

            {pagelinks.length > 10 &&
                _.map(pagelinks, pl =>{
                    if(pl == page){
                        return <span style={{'marginRight':'5px', 'textDecoration':'underline', 'opacity':0.3}}>{pl}</span>
                    }else if(pl < (page+5) && pl > (page-5) ){
                        return <span onClick={() => setPage(pl)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>{pl}</span>
                    }
                })
            }

            {page < numPages &&
                <span onClick={() => setPage(page+1)}  style={{'marginRight':'5px', 'cursor':'pointer'}}>&gt;&gt;</span>
             }
             {page == numPages &&
                <span style={{'marginRight':'5px', 'opacity':0.3}}>&gt;&gt;</span>
             }

            {page < numPages &&
                " ("+((page-1)*perPage+1) + "-" + page*perPage+" of "+total+")"
            }
            {page == numPages &&
                " ("+((page-1)*perPage+1) + "-" + total+" of "+total+")"
            }
        </Grid>
        <Grid sm={12} md={4}>

        {top &&
          <div className={classes.searchControls}>
            {date_search &&
              <input
                type="date"
                name="datesearch"
                id="datesearch"
                onChange={onChangeDate}
              />
            }

            <label
              htmlFor="searchterm"
              className={classes.searchLabel}
            >
              Search
            </label>

            <input
              type="text"
              name="searchterm"
              id="searchterm"
              defaultValue=""
              onChange={onChangeSearchterm}
            />
          </div>
        }

        </Grid>
        <br/>
        </Grid>
  }

  return(<>
    {createPaginationLinks(true)}

    <table style={{'width':'100%'}}>
    <tr style={{'borderBottom':'2px solid  gray'}}>
    {_.map(header_names, hn => {
        return <th style={{'padding':'10px'}}>{hn}</th>
    })}

    {window.innerWidth > 1080 &&
        _.map(optional_header_names, hn => {
        return <th style={{'padding':'10px'}}>{hn}</th>
    })
    }

    {view_request !== undefined &&
      <th className={classes.textAlignRight}>View</th>
    }
    {detail_get_url !== undefined &&
        <th className={classes.textAlignRight}>Edit</th>
    }
        </tr>
        {_.map(entries, entry => {
            return <tr style={{'borderBottom': '1px solid gray'}}>
                {_.map(column_names, cn => {
                  let value = get(entry, cn);
                  
                  if (cn === "state") {
                    value = ecosackState(value);
                  }

                  if (cn === "lifecycle.picked_up") {
                    if (value) {
                      value = utc_timestamp_to_hours_ago_string(value);
                    } else {
                      value = "";
                    }
                  }

                  if ((cn === "id_tenant" || cn === "name_tenant") && !value) {
                    value = "Unassigned";
                  }

                  return <td style={{ padding: '10px' }}>{value}</td>;
                })}

                {window.innerWidth > 1080 &&
                    _.map(optional_column_names, cn => {
                    return <td style={{'padding':'10px'}}>{entry[cn]}</td>
                })
                }
        {view_request !== undefined &&
          <ViewComponent
            rowData={entry}
            detail_get_url={view_request(entry) ?? detail_get_url}
            view_fields={view_fields}
          />
        }
        {detail_get_url !== undefined &&
                <EditComponent
                  {...props}
                  rowData={entry}
                  />
      }
            </tr>
        })
    }
    </table>

    {createPaginationLinks()}

    {add_new_url !== undefined &&
      <AddComponent
          add_new_url={add_new_url}
          editable_fields={editable_fields}
        />
    }

  </>)
}

export default PaginatedList